/* Women shopping enhancements. Native form POST is retained without JavaScript. */
(() => {
  if (window.eliaCommerceInstalled) return;
  window.eliaCommerceInstalled = true;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-elia-quick]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity() || form.dataset.busy) return;
    const button = event.submitter || form.querySelector('[type="submit"]'), error = form.querySelector('[role="alert"]');
    error.hidden = true;
    const data = new FormData(form), variantId = String(data.get('id'));
    // Preview uses its saved catalogue and cannot submit an order.
    if (window.eliaDemoCart && window.eliaCatalog) {
      const p = window.eliaCatalog.find(p => String(p.id) === form.dataset.product);
      const v = p?.variants.find(v => String(v.id) === variantId);
      if (!p?.available || !v?.available || (p.product_type === 'variable' && !p.variant_snapshot)) {
        error.textContent = 'Ova opcija nije dostupna u sačuvanom katalogu.'; error.hidden = false; return;
      }
      form.dispatchEvent(new CustomEvent('elia:quick-added', { bubbles: true }));
      window.eliaDemoCart.add({ productId: p.id, variantId: v.id, title: p.title, image: p.gallery[0].src,
        options: v.title || [v.size, v.color].filter(Boolean).join(' · '), price: v.price, source_url: p.source_url });
      return;
    }
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    button.disabled = true; form.dataset.busy = 'true'; button.setAttribute('aria-busy', 'true');
    try {
      if (cart) {
        data.append('sections', cart.getSectionsToRender().map(s => s.id).join(','));
        data.append('sections_url', location.pathname);
        cart.setActiveElement(form.eliaQuickOpener || button);
      }
      const response = await fetch(window.routes?.cart_add_url || form.action, {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Artikal nije dodat. Proveri dostupnost i pokušaj ponovo.');
      form.dispatchEvent(new CustomEvent('elia:quick-added', { bubbles: true }));
      if (cart) { cart.classList.remove('is-empty'); cart.renderContents(result); }
      else location.assign(window.routes?.cart_url || '/cart');
    } catch (e) {
      error.textContent = e.message || 'Dodavanje nije uspelo. Pokušaj ponovo.'; error.hidden = false;
    } finally {
      button.disabled = false; button.removeAttribute('aria-busy'); delete form.dataset.busy;
    }
  });

  if (!customElements.get('elia-sticky-buy')) customElements.define('elia-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      const section = this.closest('product-info');
      if (!section) return;
      this.button = this.querySelector('button');
      const getButton = () => document.getElementById(this.dataset.form)?.querySelector('[name="add"]');
      this.sync = () => {
        const source = getButton();
        if (!source) { this.hidden = true; return; }
        if(this.button.textContent !== source.textContent.trim()) this.button.textContent = source.textContent.trim();
        const disabled=source.disabled || source.getAttribute('aria-disabled') === 'true';
        if(this.button.disabled!==disabled)this.button.disabled=disabled;
      };
      this.button.onclick = () => { const source = getButton(); if (source && !source.disabled) source.click(); };
      this.mutation = new MutationObserver(this.sync);
      this.mutation.observe(section, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      this.observer = new IntersectionObserver(entries => {
        const e = entries[0]; this.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      });
      const source = getButton(); if (source) this.observer.observe(source);
      this.sync();
    }
    disconnectedCallback() { this.mutation?.disconnect(); this.observer?.disconnect(); }
  });
})();
